export const box =
  /^(&{3,})([^\n\s]*)(?: +([^\n]+?))??(?: +\[([a-zA-Z\d:-]+?)\])?[^\S\n]*\n([\s\S]+?)\1 *(?:\n+|$)/
